const state = {
    banks: [],
    branches: [],
    notifications: [],
    proposal_status: [],
    states: []
};

export default state;